import * as React from 'react';
import { Overlay } from 'components/Overlay';
import MusicGenre from './MusicGenre';
import allLoops from './loops';
import { storeDispatch } from 'state/Store';
import * as Actions from 'state/actions';

interface GenreButtonProps {
  genre: MusicGenre;
}
const GenreButton: React.FunctionComponent<GenreButtonProps> = props => {
  const { genre } = props;
  const imageName = genre
    .split('&')
    .join('and')
    .split(' ')
    .join('-')
    .toLowerCase();
  return (
    <div
      className="genre-button"
      style={{ backgroundImage: `url(/media/music-genres/${imageName}.svg)` }}
      onClick={() => {
        storeDispatch(Actions.showLoopSelector(genre));
      }}
    >
      {genre}
    </div>
  );
};

export const GenreSelection: React.FunctionComponent<{}> = () => {
  let genres: MusicGenre[] = [];
  allLoops.forEach(loop => {
    const loopGenre = loop.genre!;
    if (!genres.includes(loopGenre)) {
      genres.push(loopGenre);
    }
  });
  genres = genres.sort();
  return (
    <Overlay title="Select genre" fullWidth={true}>
      <div className="genres-container">
        {genres.map(g => (
          <GenreButton genre={g} key={g} />
        ))}
      </div>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/audio-editing/GenreSelection.tsx